import { Image } from 'antd';
import { useEffect, useState } from 'react';

const TaskerPhotos = (props: { imageArray: string[] }) => {
    const [newPhotos, setNewPhotos] = useState<string[][]>([]);
    const [defaultStartIndex, setDefaultStartIndex] = useState(5);
    const [pageIndex, setPageIndex] = useState(1);
    const [maxPage, setMaxPage] = useState(1);
    useEffect(() => {
        const comWidth = document.getElementById('photo-com')?.clientWidth;
        const lists: string[][] = [];
        let list: string[] = [];
        const newList: string[] = [];
        const defaultSize = comWidth ? Math.trunc((comWidth - 40) / 130) : 5;
        setDefaultStartIndex(defaultSize);
        setMaxPage(Math.ceil(props.imageArray.length / defaultSize));
        let startIndex = defaultSize;
        props.imageArray.forEach((i, index) => {
            newList.push(i);
            if (index + 1 < startIndex) {
                list.push(i);
                if (index + 1 === props.imageArray.length) {
                    lists.push([...list]);
                }
            } else {
                lists.push([...list, i]);
                list = [];
                startIndex = startIndex + defaultSize;
            }
        });
        setNewPhotos(lists);
    }, [props.imageArray]);
    return (
        <div className="content-card photo-com" id="photo-com">
            <div className="flex-between">
                <div className="card-title">Photos</div>
                {props.imageArray.length > defaultStartIndex ? (
                    <div className="next-btn">
                        <img
                            style={{
                                cursor: pageIndex === 1 ? 'no-drop' : 'pointer',
                                opacity: pageIndex === 1 ? 0.5 : 1,
                            }}
                            src={require('@/assets/images/left-icon.png')}
                            alt=""
                            onClick={() => {
                                if (pageIndex > 1) setPageIndex(pageIndex - 1);
                            }}
                        />
                        <img
                            style={{
                                cursor: pageIndex === maxPage ? 'no-drop' : 'pointer',
                                opacity: pageIndex === maxPage ? 0.5 : 1,
                            }}
                            src={require('@/assets/images/right-icon.png')}
                            alt=""
                            onClick={() => {
                                if (pageIndex < maxPage) setPageIndex(pageIndex + 1);
                            }}
                        />
                    </div>
                ) : (
                    ''
                )}
            </div>
            {newPhotos.length ? (
                <div className="task-photos one-photo tasker-photos">
                    {newPhotos[pageIndex - 1].map((i, index) => {
                        return <Image key={'task-photo' + index} src={i} />;
                    })}
                </div>
            ) : (
                <div className="no-photo">No photo</div>
            )}
        </div>
    );
};
export default TaskerPhotos;
